import React, { useEffect, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { X, Camera } from 'lucide-react';

const BarcodeScanner = ({ onScan, onClose }) => {
  const scannerRef = useRef(null);
  const regionRef = useRef(null);

  useEffect(() => {
    const html5QrCode = new Html5Qrcode("reader", {
      formatsToSupport: [
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
      ],
      verbose: false,
    });
    scannerRef.current = html5QrCode;

    // Book barcodes (EAN-13/UPC-A) are 1D and wide, so use a wide rectangular
    // qrbox rather than a square, and a higher fps for faster/more accurate reads.
    const config = { fps: 15, qrbox: { width: 280, height: 120 } };

    html5QrCode.start(
      { facingMode: "environment" },
      config,
      (decodedText) => {
        // Successfully scanned
        onScan(decodedText);
        stopScanner();
      },
      (errorMessage) => {
        // parse error, ignore it
      }
    ).catch((err) => {
      console.error("Scanner failed to start", err);
    });

    return () => {
      stopScanner();
    };
  }, []);

  const stopScanner = async () => {
    if (scannerRef.current && scannerRef.current.isScanning) {
      try {
        await scannerRef.current.stop();
      } catch (err) {
        console.error("Failed to stop scanner", err);
      }
    }
  };

  return (
    <div style={scannerOverlay}>
      <div style={scannerContainer}>
        <div style={header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Camera size={20} color="var(--accent)" />
            <span style={{ fontWeight: 'bold' }}>Scan ISBN Barcode</span>
          </div>
          <button onClick={onClose} style={closeBtn}><X size={24} /></button>
        </div>

        <div id="reader" style={{ width: '100%', minHeight: '300px', backgroundColor: '#000' }}></div>

        <p style={tip}>Center the barcode in the box to scan</p>
      </div>
    </div>
  );
};

const scannerOverlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 5000,
  display: 'flex', alignItems: 'center', justifyContent: 'center'
};

const scannerContainer = {
  width: '100%', maxWidth: '500px', padding: '20px',
  backgroundColor: 'var(--bg-card)', borderRadius: '24px',
  position: 'relative'
};

const header = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  marginBottom: '20px', color: 'var(--text-main)'
};

const closeBtn = {
  background: 'none', border: 'none', color: 'var(--text-soft)', cursor: 'pointer'
};

const tip = {
  textAlign: 'center', color: 'var(--text-soft)', fontSize: '0.8rem', marginTop: '15px'
};

export default BarcodeScanner;
